import React from 'react';
import {
  Button,
} from 'react-bootstrap';
import { ReactComponent as IconCheck } from 'assets/icons/check.svg';

function ButtonImInterested( { opportunityInterestsme }:{ opportunityInterestsme: ( ) => void } ) {
  return (
    <Button
      variant="icon-orange"
      onClick={opportunityInterestsme}
    >
      <span className="btn-icon-rounded">
        <IconCheck height={20} />
      </span>
      Me interesa
    </Button>
  );
}

export default ButtonImInterested;
